import React from 'react'
import Scenario from 'components/Scenario'
import scenarios from 'data/scenarios';


const Relationship = () => {
  return (
    <Scenario scenarioData={scenarios.relationships} />
    
  )
}

export default Relationship